import { motion } from "framer-motion"
import { Card, CardProps } from "./card"
import { forwardRef } from "react"

interface AnimatedCardProps extends CardProps {
  delay?: number;
  animationType?: "fadeInUp" | "fadeIn" | "scaleIn" | "slideInLeft" | "slideInRight";
}

const animations = {
  fadeInUp: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 }
  },
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
  },
  scaleIn: {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 }
  },
  slideInLeft: {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 }
  },
  slideInRight: {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 20 }
  }
};

export const AnimatedCard = forwardRef<HTMLDivElement, AnimatedCardProps>(
  ({ children, delay = 0, animationType = "fadeInUp", ...props }, ref) => {
    const animation = animations[animationType];
    
    return (
      <motion.div
        ref={ref}
        initial={animation.initial}
        animate={animation.animate}
        exit={animation.exit}
        transition={{
          duration: 0.4,
          delay,
          ease: [0.25, 0.1, 0.25, 1], // Custom easing for smooth feel
        }}
        whileHover={{
          y: -8,
          boxShadow: "0 20px 40px -10px rgba(92, 225, 230, 0.3)",
        }}
        transition-duration="0.2s"
      >
        <Card {...props}>{children}</Card>
      </motion.div>
    );
  }
);

AnimatedCard.displayName = "AnimatedCard";
